import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorksShiftsDt from '@/services/dataTransferModules/worksShiftsDt'

export default function useWorksShifts(params = {}) {
	const worksShiftsDt = new WorksShiftsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingWorksShift: {
			name: '',
			start_time: '',
			end_time: '',
			days_of_week: [],
		},
		fieldsToPatch: ['name', 'start_time', 'end_time', 'days_of_week'],
	}

	const {
		loadEntityFlags: flags,

		entities: worksShifts,
		getEntities: getWorksShifts,

		createEntity: createWorksShift,

		entity: worksShift,
		getEntity: getWorksShift,

		patchEntity: putWorksShift,
		updateEntity: updateWorksShift,

		deleteEntity: deleteWorksShift,
	} = useBlProviders(
		worksShiftsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Pay rate loading error'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error creating works staff payment rates norm'),

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		defaults,
		worksShifts,
		worksShift,
		getWorksShifts,
		getWorksShift,
		createWorksShift,
		putWorksShift,
		updateWorksShift,
		deleteWorksShift,
	}
}
